import {
  HL7DocumentType,
  HL7QueryType,
  HL7MessageGroup,
  HL7TemplateRuleDto,
} from '@lmt/shared-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export type TemplateRuleInfo = HL7TemplateRuleDto & {
  messageTypeId: string | null;
};

export function useHL7MessageGroupsList() {
  const i18n = useTranslation();
  return useMemo(() => {
    return [
      {
        value: HL7MessageGroup.DataBlock,
        displayValue: i18n.t('hl7.template_rules.template_types.data_block'),
      },
      {
        value: HL7MessageGroup.Document,
        displayValue: i18n.t('hl7.template_rules.template_types.document'),
      },
      {
        value: HL7MessageGroup.Query,
        displayValue: i18n.t('hl7.template_rules.template_types.query'),
      },
    ];
  }, [i18n.i18n.language]);
}

export function useHL7DocumentTypesList() {
  const i18n = useTranslation();
  return useMemo(() => {
    return [
      {
        value: HL7DocumentType.MDM_T01,
        displayValue: i18n.t('hl7.template_rules.document_types.mdm_t_1'),
        messageGroup: HL7MessageGroup.Document,
      },
      {
        value: HL7DocumentType.MDM_T02,
        displayValue: i18n.t('hl7.template_rules.document_types.mdm_t_2'),
        messageGroup: HL7MessageGroup.Document,
      },
      {
        value: HL7DocumentType.MDM_T09,
        displayValue: i18n.t('hl7.template_rules.document_types.mdm_t_9'),
        messageGroup: HL7MessageGroup.Document,
      },
      {
        value: HL7DocumentType.MDM_T10,
        displayValue: i18n.t('hl7.template_rules.document_types.mdm_t_10'),
        messageGroup: HL7MessageGroup.Document,
      },
      {
        value: HL7DocumentType.MDM_T11,
        displayValue: i18n.t('hl7.template_rules.document_types.mdm_t_11'),
        messageGroup: HL7MessageGroup.Document,
      },
    ];
  }, [i18n.i18n.language]);
}

export function useHL7QueryTypesList() {
  const i18n = useTranslation();
  return useMemo(() => {
    return [
      {
        value: HL7QueryType.PatientInformationQuery,
        displayValue: i18n.t(
          'hl7.template_rules.query_types.patient_information_query',
        ),
        messageGroup: HL7MessageGroup.Query,
      },
    ];
  }, [i18n.i18n.language]);
}

export function getMessageTypeIdFromRuleDto(rule: HL7TemplateRuleDto) {
  switch (rule.messageGroup) {
    case HL7MessageGroup.DataBlock:
      return rule.dataBlockTypeId + '_' + HL7MessageGroup.DataBlock;
    case HL7MessageGroup.Document:
      return rule.hL7DocumentType + '_' + HL7MessageGroup.Document;
    case HL7MessageGroup.Query:
      return rule.hL7QueryType + '_' + HL7MessageGroup.Query;
    default:
      return null;
  }
}

export function getMessageTypeFromRuleInfo(
  rule: TemplateRuleInfo,
  type: HL7MessageGroup,
) {
  if (rule.messageTypeId && type === rule.messageGroup) {
    const messageTypeId = rule.messageTypeId.slice(0, -2);
    return parseInt(messageTypeId);
  } else {
    return null;
  }
}
